import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Briefcase, Users, DollarSign, AlertCircle, ArrowRight, Wallet, Receipt } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => { api.get("/admin/stats").then(r => setStats(r.data)); }, []);

  if (!stats) return <div className="p-8 text-center">Indlæser...</div>;

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
      <h1 className="text-3xl font-bold mb-2">Admin dashboard</h1>
      <p className="text-muted-foreground mb-8">Oversigt over platformen</p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <Stat label="Brugere" value={stats.total_users} icon={<Users />} />
        <Stat label="Jobs i alt" value={stats.total_jobs} icon={<Briefcase />} sub={`${stats.open_jobs} åbne`} />
        <Stat label="Total omsætning" value={`${stats.total_revenue.toLocaleString("da-DK")} kr.`} icon={<DollarSign />} />
        <Stat label="Kommission (20%)" value={`${stats.total_commission.toLocaleString("da-DK")} kr.`} icon={<Receipt />} />
      </div>

      <div className="grid sm:grid-cols-3 gap-4">
        <AdminLink to="/admin/payouts" icon={<Wallet />} title="Udbetalinger" badge={stats.pending_payouts} desc="Behandl chauffør-udbetalinger" />
        <AdminLink to="/admin/disputes" icon={<AlertCircle />} title="Tvister" badge={stats.pending_disputes} desc="Løs uoverensstemmelser" />
        <AdminLink to="/admin/finance" icon={<Receipt />} title="Finans" desc="Se alle transaktioner" />
      </div>
    </div>
  );
}

function Stat({ label, value, icon, sub }) {
  return (
    <Card className="p-5">
      <div className="w-10 h-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center mb-3 [&>svg]:w-5 [&>svg]:h-5">{icon}</div>
      <p className="text-2xl font-bold">{value}</p>
      <p className="text-xs text-muted-foreground">{label}{sub && <span className="ml-1 text-primary">· {sub}</span>}</p>
    </Card>
  );
}

function AdminLink({ to, icon, title, desc, badge }) {
  return (
    <Link to={to}>
      <Card className="p-5 hover:shadow-md hover:-translate-y-0.5 transition-all cursor-pointer">
        <div className="flex items-start justify-between mb-3">
          <div className="w-10 h-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center [&>svg]:w-5 [&>svg]:h-5">{icon}</div>
          {badge > 0 && <span className="text-xs font-bold bg-destructive text-destructive-foreground rounded-full px-2 py-0.5">{badge}</span>}
        </div>
        <h3 className="font-semibold mb-1">{title}</h3>
        <p className="text-sm text-muted-foreground mb-3">{desc}</p>
        <span className="text-xs text-primary font-medium inline-flex items-center gap-1">Åbn <ArrowRight className="w-3 h-3" /></span>
      </Card>
    </Link>
  );
}
